export enum Role {
  SuperAdmin = 'SuperAdmin',
  Owner = 'Owner',
  User = 'User',
  AccountAdmin = 'AccountAdmin',
}
